/* eslint-disable prettier/prettier */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Accordion } from 'flowbite-react';
import { menucontrol } from '../../features/togglebuttonSlice';
import { addTitle, addTitleEmergency, addTitlePermanent } from '../../features/campaignMenuSlice';
import { addToCart } from '../../features/usercartSlice';
import { getFromLocalStorage } from '../helper/authorizationHelper';
import { getAsync, postAsync } from '../helper/axiosHelper';
import { uuid4 } from '../../libs/uuid4';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { addMenuTitle } from '../../features/MainMenuTitleSlice';

const UserMenu = ({ isAdmin, isAuthenticated, user }) => {
  const valuecart = useSelector((state) => state.usercart.usercart);
  const isActive = useSelector((state) => state.toggle.isActive);
  const [data, setData] = useState([]);
  const [mobileTopHeader, setMobileTopHeader] = useState(false);
  const [subCampaigns, setSubCamaigns] = useState([]);
  const [subParmanent, setSubParmanent] = useState([]);
  const [subEmergency, setSubEmergency] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [epUserID, setEpUserID] = useState(null);
  //const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };
  const getcartlist = async () => {
    const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
    dispatch(addToCart(res?.data));
    // setValuecart(res?.data);
  };

  useEffect(() => {
    (async () => {
      try {
        // 1st API call
        // const menuResponse = await getAsync('CMSMenu/GetCMSMenusUser');
        // dispatch(addMenuTitle(menuResponse?.data));
        // setData(menuResponse?.data);

        // 2nd API call
        const campaignRes = await getAsync('APIClient/CampaignModuleTypesSHJC');
        if (campaignRes) {
          dispatch(addTitle(campaignRes?.data));
          setSubCamaigns(campaignRes?.data);
        }

        // 3rd API call
        const permanentcampaign = await getAsync('APIClient/permanentcampaignsmodulesSHJC');
        if (permanentcampaign) {
          dispatch(addTitlePermanent(permanentcampaign?.data));
          setSubParmanent(permanentcampaign?.data);
        }

        // 4th API call
        const emergencycampaign = await getAsync('APIClient/EmergencyCampaignsMoudulesSHJC');
        if (emergencycampaign) {
          dispatch(addTitleEmergency(emergencycampaign?.data));
          setSubEmergency(emergencycampaign?.data);
        }
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
      }
    })();
  }, []);

   useEffect(() => {
      (async () => {
        const response = await getAsync('CMSMenu/GetCMSMenusUser');
        if (response?.data) {
           setData(response.data);
  
          // Transform the data inside setData scope
          const updatedArray = response.data?.map((obj) => ({
              menuItemID: obj?.shjcApiID,
              ar_SA: obj?.ar_SA,
              en_US: obj?.en_US,
            }));
  
          if (updatedArray?.length) {
            dispatch(addMenuTitle(updatedArray));
          }
        }
      })();
    }, [dispatch]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID != null) {
      getcartlist();
    }
  }, [epUserID]);

  const handleLogout = useCallback(() => {
    // Handle logout logic here
    //localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('upid');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userName');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('statusCode');
    localStorage.removeItem('message');
    localStorage.removeItem('mobile');
    toast.success(t('msg_logoutSuccess'));
    localStorage.setItem('isHome', true);
    dispatch(menucontrol(true));
    window.location.href = '/donorLogin';
  }, [dispatch, t]);

  const handleClick = () => {
    localStorage.setItem('isHome', true);
    dispatch(menucontrol(true));
    window.location.href = '/';
  };

  const handleHamburgerClick = () => {
    setMobileTopHeader(true);
  };
  const handleCloseClick = () => {
    setMobileTopHeader(false);
  };
  const handleRoute = (id) => {
    const link = '/user';
    navigate(link, { state: { id: id } });
  };
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const toggleSubmenu = () => {
    setIsSubmenuOpen(true);

    setTimeout(() => {
      setIsSubmenuOpen(false);
    }, 300);
  };
  return (
    <header>
      <nav
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        className="bg-white align-middle items-center fixed w-full z-20 "
      >
        <div className={`bg-gray-200 w-full xl:flex relative  sm:z-2  top-0 start-0  `}>
          <Link
            onClick={handleClick}
            className={`flex items-center rtl:space-x-reverse ${isActive ? 'mx-5  sm:ps-12' : 'mx-5 sm:ps-12'}`}
          >
            <div
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="2500"
              className={`absolute items-center flex  xl:bg-gray-50 pt-2 lg:pt-8 xl:pb-6 mx-3 xl:rounded-b-3xl z-20 lg:px-5 top-0 justify-center`}
            >
              <img src="/assets/logo.png" className="lg:h-15 xl:h-20 h-10" alt="SHJC" />
            </div>
          </Link>
          <div
            className={`items-center bg-slate-200 w-full p-2 xl:justify-between  flex xl:flex ${isActive ? ' flex-row justify-end' : ' flex-row justify-end'}`}
          >
            <button
              id="triggerEl"
              type="button"
              onClick={handleHamburgerClick}
              className={`flex  justify-center items-center w-10 h-10 xl:hidden   z-20 text-sm text-gray-500 rounded-lg absolute hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 ${isActive ? 'right-0 ' : ' left-0'}`}
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
            <div className=" bg-slate-200">
              <ul
                className={`xl:flex hover:text-customgreen hidden flex-col max-[600px]:justify-end items-center text-sm  md:p-0 font-medium rounded-lg bg-gray-200  md:mt-0  md:bg-gray-200 ${isActive ? 'space-x-8   flex-row  ms-6' : ' ms-6 flex-row space-x-8'}`}
              >
                <Link to={'/user'}>
                  <li className="text-customgreen hover:text-customgreen mx-2">{t('home')}</li>
                </Link>
                <li className="dropdown text-customgreen">
                  {t('Services')}
                  <KeyboardArrowDownIcon />
                  <ul className="dropdown_menu">
                    <li>
                      {t('Ambassadors of Goodness')}
                      <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                      <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu  `}>
                        {[
                          { title_EN: 'Register List', path: '/GWARegisterList' },
                          { title_EN: 'Campaign', path: '/CampaignList' },
                          ,
                          { title_EN: 'Project List', path: '/GWAProjectList' },
                        ]?.map((data, index) => (
                          <Link
                            key={index}
                            to={data?.path}
                            className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                          >
                            <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                              {t(`${data?.title_EN}`)}
                            </li>
                            <hr className="text-gray-400" />
                          </Link>
                        ))}
                      </ul>
                    </li>
                    <hr className="text-gray-400" />
                    <Link
                      to={'/ServiceForDeadList'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('Righteousness towards the dead')}</li>
                    </Link>
                    <hr className="text-gray-400" />
                    <Link
                      to={'/Gift'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('Jude Gifts')}</li>
                    </Link>
                    <hr className="text-gray-400" />
                    <li>
                      {t('The Guide to Goodness')}
                      <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                      <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu  `}>
                        {[
                          { title_EN: 'Service For You Registration List', path: '/ServiceFYUPRegistList' },
                          { title_EN: 'Service for You Points', path: '/Points' },
                        ]?.map((data, index) => (
                          <Link
                            key={index}
                            to={data?.path}
                            className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                          >
                            <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                              {t(`${data?.title_EN}`)}
                            </li>
                            <hr className="text-gray-400" />
                          </Link>
                        ))}
                      </ul>
                    </li>
                    <hr className="text-gray-400" />
                    <li>
                      {t('Other relevant service categories')}
                      <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                      <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu  `}>
                        {[
                          { title_EN: 'Idea Suggestion', path: '/IdeaSuggUPRegistrationList' },
                          { title_EN: 'Volunteer List', path: '/volunteerlist' },
                          { title_EN: 'Volunteer Event Selection List', path: '/VolunteerUpEventSeleList' },
                        ]?.map((data, index) => (
                          <Link
                            key={index}
                            to={data?.path}
                            className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                          >
                            <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                              {t(`${data?.title_EN}`)}
                            </li>
                            <hr className="text-gray-400" />
                          </Link>
                        ))}
                      </ul>
                    </li>
                    <hr className="text-gray-400" />
                  </ul>
                </li>
                <li className="dropdown text-customgreen">
                  {t('Donation')}
                  <KeyboardArrowDownIcon />
                  <ul className="dropdown_menu">
                    {/* <Link
                      to={'/user/GeneralDonation'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('Quick Donation')}</li>
                    </Link>
                    <hr className="text-gray-400" />
                    <li className="dropdown_menuCh">
                      {t('Campaigns')}
                      <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                      <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu   `}>
                        <li>
                          {t('Seasonal Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menuCh   `}>
                            {subCampaigns?.map((data, index) => (
                              <>
                                <Link key={index} to={`/user/CampaignDonation/${data?.moduleID}`}>
                                  <li onClick={handleCloseClick}>
                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                  </li>
                                </Link>
                                <hr className="text-gray-400" />
                              </>
                            ))}
                          </ul>
                        </li>
                        <li>
                          {t('Permanent Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menuCh   `}>
                            {subParmanent?.map((data, index) => (
                              <>
                                <Link key={index} to={`/user/PermanentCampaigns/${data?.moduleID}`}>
                                  <li onClick={handleCloseClick}>
                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                  </li>
                                </Link>
                                <hr className="text-gray-400" />
                              </>
                            ))}
                          </ul>
                        </li>
                        <li>
                          {t('Emergency Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menuCh   `}>
                            {subEmergency?.map((data, index) => (
                              <>
                                <Link key={index} to={`/user/EmergencyCampaigns/${data?.moduleID}`}>
                                  <li onClick={handleCloseClick}>
                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                  </li>
                                </Link>
                                <hr className="text-gray-400" />
                              </>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <hr className="text-gray-400" /> */}
                    {
                      // data?.map((items) => (
                      <>
                        <li>
                          {/* {t(
                            `${isActive ? items?.ar_SA : items?.en_US.charAt(0).toUpperCase() + items?.en_US.slice(1)} `,
                          )} */}
                          {t('Sponsorships')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu  `}>
                            {data?.map((childItem, childIndex) => (
                              <Link
                                to={`/user/${childItem?.pageLink}/${childItem?.shjcApiID}`}
                                className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                                key={uuid4()}
                              >
                                <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                                  {t(
                                    `${isActive ? childItem?.ar_SA : childItem?.en_US.charAt(0).toUpperCase() + childItem?.en_US.slice(1)}`,
                                  )}
                                </li>
                                <hr className="text-gray-400" />
                              </Link>
                            ))}
                          </ul>
                        </li>
                        <hr className="text-gray-400" />
                      </>
                      // ))
                    }
                  </ul>
                </li>
                <li className="dropdown text-customgreen">
                  {t('media')}
                  <KeyboardArrowDownIcon />
                  <ul className="dropdown_menu">
                    <Link
                      to={'/user/PressRelease'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('navItem_pressRelease')}</li>
                    </Link>
                    <hr className="text-gray-400" />
                    <Link
                      to={'/user/PhotoGallery'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('Photo Gallery')}</li>
                    </Link>
                    <hr className="text-gray-400" />
                    <Link
                      to={'/user/VideoGallery'}
                      className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                    >
                      <li className=" space_align">{t('Video Gallery')}</li>
                    </Link>
                  </ul>
                </li>
              </ul>
            </div>
            <div className={`lg:flex ${isActive ? 'mx-2  ' : 'mx-2 '} `}>
              <ul className={` flex justify-center ${isActive ? '  ' : ' '} xl:flex-row `}>
                <li className="text-customgreen ">
                  <button onClick={() => handleRoute(user?.id)}>
                    <svg
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.000000pt"
                      height="18.000000pt"
                      viewBox="0 0 350.000000 350.000000"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      {' '}
                      <g
                        transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                        fill="#1d8b4b"
                        stroke="none"
                      >
                        {' '}
                        <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                        <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                      </g>{' '}
                    </svg>
                    {/* {user?.name} */}
                  </button>
                  {/* </Link> */}
                </li>

                <li>
                  <Link
                    to="/add-cart"
                    className={`sm:mx-3 block relative text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen  dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent  text-sm`}
                  >
                    <CardGiftcardIcon className="text-customgreen mx-1" />
                    <div className={`top-1 absolute  ${isActive ? 'right-3' : 'left-3'}`}>
                      <p className="flex h-1 w-1 items-center justify-center rounded-full bg-customgreen p-2.5 text-xs text-white">
                        {valuecart?.length}
                      </p>
                    </div>
                  </Link>
                </li>
                <li className="text-customgreen ">
                  <button
                    type="button"
                    onClick={handleLogout}
                    className={` text-xs font-medium text-center inline-flex items-center  bg-transparent  text-customorange`}
                  >
                    <svg
                      className="h-6 w-5 text-customorange"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M14 12h-4v-12h4v12zm4.213-10.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z" />
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {mobileTopHeader && (
            <div
              className={`xl:hidden text-white maindiv fixed top-0 z-30 ${isActive ? 'right-0' : 'left-0'} h-screen w-2/3 bg-green-50 overflow-y-auto scrollbar-thin scrollbar-thumb-green-600 scrollbar-track-gray-200`}
            >
              <div className={` flex p-2 mx-2 z-40 top-0 justify-end`}>
                <button
                  onClick={handleCloseClick}
                  className="  text-customgreen rounded-md hover:bg-customgreen hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className=" my-2 mx-auto  w-[90%]">
                <div
                  className={`xl:hidden flex-col items-center  font-medium rounded-lg bg-green-50  md:bg-gray-200 ${isActive ? 'space-x-4   flex-row' : ' flex-row  space-x-0'}`}
                >
                  {' '}
                  <Accordion collapseAll className=" bg-green-50 text-center !border-none">
                    <li className={`${isActive ? 'text-right' : 'text-left'} `}>
                      <Link
                        to={'/user'}
                        onClick={handleCloseClick}
                        className="accordion-heading dark:divide-gray-0  p-2 hover:text-customgreen hover:bg-gray-100 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen "
                      >
                        {t('home')}
                      </Link>
                    </li>
                    <Accordion.Panel className="text-customgreen">
                      <Accordion.Title className="accordion-heading p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                        {t('Services')}
                      </Accordion.Title>
                      <Accordion.Content className="p-2 bg-white">
                        <ul className="space-y-2">
                          <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                            {!isAdmin && (
                              <Accordion className={`!border-none ${isActive ? 'mr-2 ' : 'ml-2 '}`}>
                                <Accordion.Panel>
                                  <Accordion.Title
                                    onClick={() => toggleMenu('Register')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                  >
                                    {t('Ambassador of Goodness')}
                                  </Accordion.Title>
                                  <hr className="text-gray-400" />
                                  {openMenu === 'Register' && (
                                    <Accordion.Content className="!p-0 ">
                                      <ul className={` ${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}>
                                        <li>
                                          <Link
                                            to="/GWARegisterList"
                                            onClick={handleCloseClick}
                                            className=" accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Register List')}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/CampaignList"
                                            onClick={handleCloseClick}
                                            className="accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Campaign')}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/GWAProjectList"
                                            onClick={handleCloseClick}
                                            className="accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Project List')}
                                          </Link>
                                        </li>
                                      </ul>
                                    </Accordion.Content>
                                  )}
                                </Accordion.Panel>
                              </Accordion>
                            )}
                          </li>

                          <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                            {!isAdmin && (
                              <Accordion className={`!border-none ${isActive ? 'mr-2 ' : 'ml-2 '}`}>
                                <Accordion.Panel>
                                  <Accordion.Title
                                    onClick={() => toggleMenu('service')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                  >
                                    {t('The Guide to Goodness')}
                                  </Accordion.Title>
                                  {openMenu === 'service' && (
                                    <Accordion.Content className="!p-0 ">
                                      <ul className={`${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}>
                                        <li>
                                          <Link
                                            to="/ServiceFYUPRegistList"
                                            onClick={handleCloseClick}
                                            className="accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Service For You Registration List')}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/Points"
                                            onClick={handleCloseClick}
                                            className="accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Service for You Points')}
                                          </Link>
                                        </li>
                                      </ul>
                                    </Accordion.Content>
                                  )}
                                </Accordion.Panel>
                              </Accordion>
                            )}
                          </li>

                          <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                            {!isAdmin && (
                              <Accordion className={`!border-none ${isActive ? 'mr-2 ' : 'ml-2 '}`}>
                                <Accordion.Panel>
                                  <Accordion.Title
                                    onClick={() => toggleMenu('Suggestion')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                  >
                                    {t('Other relevant service categories')}
                                  </Accordion.Title>
                                  {openMenu === 'Suggestion' && (
                                    <Accordion.Content className="!p-0 ">
                                      <ul className={`${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}>
                                        <li>
                                          <Link
                                            to="/IdeaSuggUPRegistrationList"
                                            onClick={handleCloseClick}
                                            className=" accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Idea Suggestion')}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/volunteerlist"
                                            onClick={handleCloseClick}
                                            className=" accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Volunteer List')}
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            to="/VolunteerUpEventSeleList"
                                            onClick={handleCloseClick}
                                            className=" accordion-children block hover:text-customgreen p-1"
                                          >
                                            {t('Volunteer Event Selection List')}
                                          </Link>
                                        </li>
                                      </ul>
                                    </Accordion.Content>
                                  )}
                                </Accordion.Panel>
                              </Accordion>
                            )}
                          </li>

                          <li
                            className={`accordion-children ${isActive ? 'text-right mr-2' : 'text-left ml-2'}  focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen`}
                          >
                            {!isAdmin && (
                              <Link
                                className="block hover:text-customgreen p-2"
                                to="/ServiceForDeadList"
                                onClick={handleCloseClick}
                              >
                                {t('Righteousness towards the dead')}
                              </Link>
                            )}
                          </li>
                          <li
                            className={`accordion-children ${isActive ? 'text-right mr-2' : 'text-left ml-2'}  focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen`}
                          >
                            {!isAdmin && (
                              <Link className="block hover:text-customgreen p-2" to="/Gift" onClick={handleCloseClick}>
                                {t('Jude Gifts')}
                              </Link>
                            )}
                          </li>
                        </ul>
                      </Accordion.Content>
                    </Accordion.Panel>

                    <Accordion.Panel className="text-customgreen">
                      <Accordion.Title className="accordion-heading p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                        {t('Donation')}
                      </Accordion.Title>
                      <Accordion.Content className="p-2 bg-white">
                        <ul className="space-y-2">
                          {/*
<li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
    {!isAdmin && (
        <Accordion className={`!border-none ${isActive ? 'mr-2 ' : 'ml-2 '}`}>
            <Accordion.Panel className="text-customgreen!">
                <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen">
                    {t('Campaigns')}
                </Accordion.Title>
                <Accordion.Content
                    className={`dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen bg-white ${isActive ? 'text-right' : 'text-left'}`}
                >
                    <ul
                        className={`flex flex-col !gap-2 ${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}
                    >
                        <li className=" dark:focus:ring-gray-0 !text-customgreen">
                            <div className="hover:text-customgreen">
                                <Accordion.Title
                                    onClick={() => toggleMenu('seasonal')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                >
                                    {t('Seasonal Campaigns')}
                                </Accordion.Title>
                                {openMenu === 'seasonal' && (
                                    <Accordion.Content
                                        className={`p-2 text-left  ${isActive ? 'text-right mr-2' : 'text-left ml-2'}`}
                                    >
                                        {subCampaigns?.map((data, index) => (
                                            <Link key={index} to={`/user/CampaignDonation/${data?.moduleID}`}>
                                                <li
                                                    onClick={handleCloseClick}
                                                    className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                                >
                                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                                </li>
                                            </Link>
                                        ))}
                                    </Accordion.Content>
                                )}
                            </div>
                        </li>

                        <li className="dark:focus:ring-gray-0 !text-customgreen">
                            <div className="hover:text-customgreen">
                                <Accordion.Title
                                    onClick={() => toggleMenu('permanent')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                >
                                    {t('Permanent Campaigns')}
                                </Accordion.Title>
                                {openMenu === 'permanent' && (
                                    <Accordion.Content
                                        className={`p-2 text-left  ${isActive ? 'text-right mr-2' : 'text-left ml-2'}`}
                                    >
                                        {subParmanent?.map((data, index) => (
                                            <Link key={index} to={`/user/PermanentCampaigns/${data?.moduleID}`}>
                                                <li
                                                    onClick={handleCloseClick}
                                                    className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                                >
                                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                                </li>
                                            </Link>
                                        ))}
                                    </Accordion.Content>
                                )}
                            </div>
                        </li>

                        <li className="dark:focus:ring-gray-0 !text-customgreen">
                            <div className="hover:text-customgreen">
                                <Accordion.Title
                                    onClick={() => toggleMenu('emergency')}
                                    className={`accordion-heading ${isActive ? 'text-right' : 'text-left'} dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer`}
                                >
                                    {t('Emergency Campaigns')}
                                </Accordion.Title>
                                {openMenu === 'emergency' && (
                                    <Accordion.Content className="p-2 text-center">
                                        {subEmergency?.map((data, index) => (
                                            <Link key={index} to={`/user/EmergencyCampaigns/${data?.moduleID}`}>
                                                <li
                                                    onClick={handleCloseClick}
                                                    className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                                >
                                                    {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                                </li>
                                            </Link>
                                        ))}
                                    </Accordion.Content>
                                )}
                            </div>
                        </li>
                    </ul>
                </Accordion.Content>
            </Accordion.Panel>
        </Accordion>
    )}
</li>
<hr className="border-gray-600" />
*/}
                          {
                            // data?.map((item) => {
                            //   return (
                            <>
                              {' '}
                              <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                                <Accordion className={`!border-none ${isActive ? 'mr-2 ' : 'ml-2 '}`}>
                                  <Accordion.Panel>
                                    <Accordion.Title className="accordion-heading p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                                      {t('Sponsorships')}
                                    </Accordion.Title>
                                    <Accordion.Content className="!p-0 ">
                                      <ul className={` ${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}>
                                        {data?.map((childItem) => (
                                          <li key={childItem.id}>
                                            <Link
                                              to={`/user/${childItem.pageLink}/${childItem.shjcApiID}`}
                                              onClick={handleCloseClick}
                                              className="accordion-children block hover:text-customgreen p-1"
                                            >
                                              {t(isActive ? childItem.ar_SA : childItem.en_US)}
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </Accordion.Content>
                                  </Accordion.Panel>
                                </Accordion>
                              </li>
                              {/* <hr className="border-gray-600" /> */}
                            </>
                            //   );
                            // })
                          }

                          {/* Other existing items */}
                          {/* <li
                            className={`accordion-children ${isActive ? 'text-right mr-2' : 'text-left ml-2'}  focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen`}
                          >
                            {!isAdmin && (
                              <Link
                                className="block hover:text-customgreen p-2"
                                to="/ServiceForDeadList"
                                onClick={handleCloseClick}
                              >
                                {t('Quick Donation')}
                              </Link>
                            )}
                          </li> */}
                        </ul>
                      </Accordion.Content>
                    </Accordion.Panel>

                    <Accordion.Panel>
                      <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                        {t('media')}
                      </Accordion.Title>
                      <Accordion.Content className="p-2 bg-white text-center">
                        <ul
                          className={` ${isActive ? 'text-right mr-2' : 'text-left ml-2'}  focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen`}
                        >
                          <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                            <Link
                              className="hover:text-customgreen"
                              to={'/user/PressRelease'}
                              onClick={handleCloseClick}
                            >
                              {t('navItem_pressRelease')}
                            </Link>
                          </li>
                          <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                            <Link
                              className="hover:text-customgreen"
                              to={'/user/PhotoGallery'}
                              onClick={handleCloseClick}
                            >
                              {t('Photo Gallery')}
                            </Link>
                          </li>
                          <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                            <Link
                              className="hover:text-customgreen"
                              to={'/user/VideoGallery'}
                              onClick={handleCloseClick}
                            >
                              {t('Video Gallery')}
                            </Link>
                          </li>
                        </ul>
                      </Accordion.Content>
                    </Accordion.Panel>
                    {/* 
                    <Accordion.Panel>
                      <Link
                        className={`${isActive ? 'text-right' : 'text-left'} accordion-heading dark:divide-gray-0 p-2 hover:text-customgreen hover:bg-gray-100 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen`}
                        onClick={handleCloseClick}
                        to={'/Gift'}
                      >
                        {t('Service For Gift')}
                      </Link>
                    </Accordion.Panel> */}
                    {/* <div>
                    <Accordion.Panel>
                      {isAuthenticated && (
                        <>
                          {navLinksData.map(
                            (el, i) =>
                              el.children && (
                                <div key={i}>
                                  <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                                    {t(`${el.name}`)}
                                  </Accordion.Title>
                                  <ul>
                                    {el?.children?.map((ele, index) =>
                                      isAdmin === ele?.isAdmin && !ele?.isHidden ? (
                                        <li className=" text-customgreen p-0" key={index}>
                                          <Accordion.Content className="p-0 accordion-children bg-white text-center">
                                            <Link
                                              className="hover:text-customgreen"
                                              to={ele.link}
                                              onClick={handleCloseClick}
                                            >
                                              {t(`${ele.name}`)}
                                            </Link>
                                          </Accordion.Content>
                                        </li>
                                      ) : null,
                                    )}
                                  </ul>
                                </div>
                              ),
                          )}
                        </>
                      )}
                    </Accordion.Panel>
                    </div> */}
                  </Accordion>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default UserMenu;
